import { theme } from '../../theme/theme'
import { IconProps } from './types'

const DEFAULT_SIZE = 48
const DEFAULT_COLOR = theme.color.black

export const Clock = ({ size = DEFAULT_SIZE, color = DEFAULT_COLOR }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8.5" stroke={color} />
    <path d="M16.5 12H12.25C12.1119 12 12 11.8881 12 11.75V8.5" stroke={color} strokeLinecap="round" />
  </svg>
)
